module.exports = {
  lineHeight: "8vh",
  redLineMargin: "9vh",
  redLineMarginSettings: "20vh",
  blueLineHeight: "0.125rem",
  redLineWidth: "2px",
};
